module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_3009.1b2969d3.png";